<template>
  <div class="meter-reading">
    <div class="card text-left d-none d-md-block">
      <div class="card-header bg-white py-2">
        <div class="row">
          <div class="col-8">
            <h5 class="mb-0">
              <b class="title">{{ location.name }}</b>
            </h5>
            <span class="title">{{ location.country }}</span>
          </div>
          <div class="col-4 my-auto">
            <span class="badge badge-secondary px-2 py-2 float-right">
              <img width="15" src="../../assets/clock.svg" alt />
              {{ location.lastUpdate }} ({{location.timezone}})
            </span>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="mx-5">
          <div class="row align-items-center justify-content-center">
            <div class="col text-center px-5" v-for="hall in location.halls" :key="hall.name">
              <img :src="hall.image" alt />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-3">
      <energy-consumption :location="location" />
    </div>
  </div>
</template>

<script>
import EnergyConsumption from "./energy-consumption";

export default {
  name: "MeterReading",
  props: {
    location: Object
  },
  components: {
    "energy-consumption": EnergyConsumption
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.card {
  font-size: 0.9rem;
}

img {
  max-width: 100%;
  max-height: 300px;
}
.badge {
  background: rgba(0, 119, 190, 0.2);
  color: #001D3E;
}

.title {
	color: #001D3E;
}
</style>
